import React, { useState } from "react";
import PropTypes from "prop-types";

import styles from "./styles";
import draImage from "../../../assets/images/dra-preguntas.png";
import { Grid } from "@material-ui/core";
import FaqAccordion from "../../../components/FaqAccordion";

export const FaqSection = ({ questions }) => {
  const classes = styles();

  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <section id="faq" className={classes.mainFaq}>
      <div className={classes.titleSectionContainer}>
        <div className={classes.titleContainer}>
          <div className={classes.lineTitle} />
          <div className={classes.titleSection}>Preguntas frecuentes</div>
        </div>
      </div>
      <Grid container className={classes.faqContainer}>
        <Grid item xs={12} md={5} className={classes.draImageContainer}>
          <img src={draImage} alt="Contacto" className={classes.draImage} />
        </Grid>
        <Grid item xs={12} md={7}>
          {questions.map((question, index) => (
            <FaqAccordion
              key={index}
              question={question}
              expanded={expanded}
              handleChange={handleChange}
            />
          ))}
        </Grid>
      </Grid>
    </section>
  );
};

FaqSection.propTypes = {
  questions: PropTypes.any
};
